var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":function($event){return _vm.toggleLayerVisibility(_vm.layer.name)}}},[_c('div',{staticClass:"layer-color",style:({
      'background-color': _vm.getLayerColor(_vm.layer.name),
      visibility: _vm.visibility
    })}),_c('div',{staticClass:"layer-name"},[_vm._v(" "+_vm._s(_vm.layer.name)+" ")]),_c('div',{staticClass:"layer-zoom-range"},[_vm._v(_vm._s(_vm.zoomRange))])])}
var staticRenderFns = []

export { render, staticRenderFns }